import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../../common/SvgIcon";
import { Button } from "../../../common/Button";
import { ContentBlockProps } from "../types";
import { Fade } from "react-awesome-reveal";
import {
  RightBlockContainer,
  Content,
  ContentWrapper,
  ButtonWrapper,
} from "./styles";

const RightBlock = ({
  title,
  content,
  callout,
  button,
  icon,
  t,
  id,
}: ContentBlockProps) => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    element.scrollIntoView({
      behavior: "smooth",
    });
  };

  const renderTitle = (titleText: string) => {
    if (titleText.includes('Pureple')) {
      const parts = titleText.split('Pureple');
      return (
        <>
          {parts[0]}
          <span className="pureple-brand">Pureple</span>
          {parts[1]}
        </>
      );
    }
    return titleText;
  };

  return (
    <RightBlockContainer>
      <Fade direction="right">
        <Row justify="space-between" align="middle" id={id}>
          <Col lg={11} md={11} sm={11} xs={24}>
            <ContentWrapper>
              <h1>{renderTitle(t(title))}</h1>
              {callout && (
                <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                  <div style={{
                    border: '3px dashed #FF4444',
                    color: '#FF4444',
                    background: 'rgba(255, 68, 68, 0.05)',
                    padding: '12px 20px',
                    borderRadius: '0px',
                    display: 'inline-block',
                    fontSize: '16px',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                    transform: 'rotate(-15deg)',
                    boxShadow: 'inset 0 0 0 2px #FF4444, 0 3px 10px rgba(255, 68, 68, 0.3)',
                    position: 'relative',
                    fontFamily: "'Special Elite', monospace"
                  }}>
                    {t(callout)}
                  </div>
                </div>
              )}
              <Content>{t(content)}</Content>
              <ButtonWrapper>
                {typeof button === "object" &&
                  button.map((item: any, id: number) => {
                    return (
                      <Button
                        key={id}
                        color={item.color}
                        fixedWidth={true}
                        onClick={() => scrollTo("about")}
                      >
                        {t(item.title)}
                      </Button>
                    );
                  })}
              </ButtonWrapper>
            </ContentWrapper>
          </Col>
          <Col lg={11} md={11} sm={12} xs={24}>
            <SvgIcon src={icon} width="100%" height="100%" />
          </Col>
        </Row>
      </Fade>
    </RightBlockContainer>
  );
};

export default withTranslation()(RightBlock);
